import { render } from "./AsignarInvitacionView.vue?vue&type=template&id=e8684bdc&ts=true"
import script from "./AsignarInvitacionView.vue?vue&type=script&lang=ts"
export * from "./AsignarInvitacionView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__